import axios from 'axios'
import router from '../router'

//对于没有独立打包部署的项目可以注释掉
// export var baseUrl = process.env.NODE_ENV === 'production' ? window.g.BASE_API : process.env.BASE_API

// 创建axios实例
const service = axios.create({
    // api的base_url
    // baseURL: baseUrl,
    baseURL: process.env.BASE_API,
    // 请求超时时间
    timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
    // Do something before request is sent
    if (sessionStorage.getItem('token')) {
        // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
        config.headers['X-Token'] = sessionStorage.getItem('token')
    }
    return config
}, error => {
    console.log("request.js网页信息" + JSON.stringify(error));
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        if(response.status ==500){
          return Promise.reject(response.data.msg)
        }
        if (response.data.result == 403) {
            console.log("没有权限，准备跳转登录 清空token然后跳转登录界面")
            sessionStorage.setItem('token', '')
            router.push({
                path: "/login",
                // 从哪个页面跳转
                querry: { redirect: router.currentRoute.fullPath }
            })
        }
        if (response.data.result == 1) {//常规错误提醒
        	//提示错误消息  并阻止页面继续向下走
        	return Promise.reject(response.data.msg)
        }
        return response;
    },
    error => {
        //网络错误
        if('Error: Network Error'==error){
          return Promise.reject("网络请求超时,请确保网络以及后台服务正常")
        }
        //路径不存在
        if(error.response.status == 404){
          return Promise.reject("请求路径不存在"+ error.response.data.path)
        }
    })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js